<template>
  <v-card
    width="400"
    elevation="24"
  >
    <v-row
      align="center"
      justify="center"
      style="height: 100%"
    >
      <v-col>
        <v-row
          align="center"
          justify="center"
          class="ma-5"
          id="login-header"
        >
          <h1> Reset Password </h1>
        </v-row>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-row
            align="center"
            justify="center"
          >
          <v-col>
              <v-row
                align="center"
                justify="center"
                style="height: 100%"
              >
                <v-text-field
                  v-model="organization"
                  color="orange"
                  class="login-form-element"
                  label="Organization"
                  rounded
                  solo
                  prepend-inner-icon="mdi-domain"
                  :disabled="true"
                />
              </v-row>
              <v-row
                align="center"
                justify="center"
                style="height: 100%"
              >
                <v-text-field
                  v-model="email"
                  color="orange"
                  class="login-form-element"
                  label="E-mail Address"
                  rounded
                  solo
                  prepend-inner-icon="mdi-email"
                  :disabled="true"
                />
              </v-row>
              <v-row
                align="center"
                justify="center"
                style="height: 100%"
              >
                <v-text-field
                  v-model="password"
                  color="orange"
                  class="login-form-element"
                  label="New Password"
                  rounded
                  solo
                  prepend-inner-icon="mdi-key"
                  type="password"
                  :rules="passwordRules"
                />
              </v-row>
              <v-row
                align="center"
                justify="center"
                style="height: 100%"
              >
                <v-text-field
                  v-model="confirmedPassword"
                  color="orange"
                  class="login-form-element"
                  label="Confirm Password"
                  rounded
                  solo
                  prepend-inner-icon="mdi-key"
                  type="password"
                  :rules="[confirmPasswordRule]"
                />
              </v-row>
              <v-row
                align="center"
                justify="center"
                style="height: 100%"
              >
                <v-btn
                  height="50px"
                  class="login-form-element"
                  color="rgb(255, 149, 24)"
                  rounded
                  @click="validateForgotPassword"
                >
                  Reset Your Password
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'Registration',
  data: () => ({
    valid: false,
    organization: '',
    email: '',
    username: '',
    password: '',
    confirmedPassword: '',
    usernameRules: [v => !!v || 'Name is required'],
    passwordRules: [v => !!v || 'Password is required']
  }),

  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo
    }),

    confirmPasswordRule () {
      return () => (this.password === this.confirmedPassword) || 'Password must match'
    }
  },

  mounted () {
    this.getUserInfoFromToken()
  },

  methods: {
    ...mapMutations(['setBearerToken']),
    ...mapActions(['requestPasswordReset', 'requestUserInfo', 'requestOrganization']),
    async validateForgotPassword () {
      if (this.$refs.form.validate()) {
        const response = await this.requestPasswordReset({
          token: this.$route.query.token,
          password: this.password
        })

        this.$emit('password-update-response', response)

        if (response.success) {
          this.$router.push('/login')
        }
      }
    },

    async getUserInfoFromToken () {
      const token = this.$route.query.token
      this.setBearerToken(token)

      console.log('requesting')

      await this.requestUserInfo()

      const organization = await this.requestOrganization(this.userInfo.organization)

      this.email = this.userInfo.email
      this.organization = organization.name
    }
  }
}
</script>

<style lang="sass" scoped>
  #login-header
    top: -10px

  .login-form-element
    width: 75%
    max-width: 75%
</style>
